export const setProjects = (state, payload) => {
  state.projects = payload
}
export const setCurrentProject = (state, payload) => {
  state.currentProject = payload
}
